import apiClient from './api_client_requests';

export default (config) => {
    return async (payload) => {
        let result = await apiClient(config).apiMethod({
            method: 'GetExpiredSweeps',
            headers: {},
            args: {
                ...payload,
            },
            urlArgs: {
                page: payload.page,
                pagesize: payload.pagesize,
            },
        });

        return result;
    };
};
